import type { Nation } from "@/types/api.types";

interface ActiveNationsProps {
  nations: Nation[];
}

export default function ActiveNations({ nations }: ActiveNationsProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-800">🏳️ Active Nations</h3>
        <span className="text-sm font-bold text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
          {nations.length} remaining
        </span>
      </div>

      <div className="space-y-2 max-h-80 overflow-y-auto">
        {nations.length === 0 ? (
          <p className="text-gray-400 text-sm text-center py-4">
            No active nations
          </p>
        ) : (
          nations.map((nation) => (
            <div
              key={nation.id}
              className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50"
            >
              {nation.flagUrl ? (
                <img
                  src={nation.flagUrl}
                  className="w-8 h-5 object-cover rounded border"
                  alt=""
                />
              ) : (
                <div className="w-8 h-5 bg-gray-200 rounded border" />
              )}
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-800">
                  {nation.name}
                </p>
                <p className="text-xs text-gray-400">{nation.code}</p>
              </div>
              {nation.groupName && (
                <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
                  {nation.groupName}
                </span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
